(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["niche-drop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scopes = new Map();
    let libPromise = null;

    const loadAnime = (url) => {
      if (!libPromise) libPromise = import(url);
      return libPromise;
    };

    const playVideos = (root) => {
      root.querySelectorAll('.nd-bg video').forEach((v) => {
        v.muted = true;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      });
    };

    /* ---------- Simple fade (IntersectionObserver) ---------- */
    const initFade = (root) => {
      const items = root.querySelectorAll('.nd-reveal');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('is-visible'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('is-visible');
              io.unobserve(e.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
      );
      items.forEach((el) => io.observe(el));
    };

    /* ---------- Anime.js: blocks slide in from the sides ---------- */
    const initAnime = async (root) => {
      const done = () => root.classList.remove('nd-anime-pending');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return done();

      let lib;
      try {
        lib = await loadAnime(root.dataset.ndLib);
      } catch (err) {
        console.warn('[Niche drop] Anime.js could not be loaded, showing content without animation.', err);
        return done();
      }
      const { animate, onScroll, stagger, createScope } = lib;

      const d = root.dataset;
      const scrub = d.ndMode !== 'once';
      const dist = Number(d.ndDistance) || 40;
      const tilt = Number(d.ndRotate) || 0;
      const smoothLevel = Number(d.ndSmooth) || 0;
      // anime.js sync: 1 = locked to scroll, closer to 0 = smoother lag
      const sync = smoothLevel === 0 ? true : Math.max(0.1, 1 - smoothLevel * 0.09);

      // Scroll trigger factory: scrub follows the scrollbar, once plays a timed animation
      const trigger = (target, enter, leave) =>
        scrub
          ? onScroll({ target, enter, leave, sync })
          : onScroll({ target, enter: '85% top', repeat: false });

      const timing = scrub ? { ease: 'outCubic', duration: 1000 } : { ease: 'outExpo', duration: 1400 };

      const scope = createScope({
        root,
        mediaQueries: { mobile: '(max-width: 749px)' },
      }).add((self) => {
        const mobile = self.matches.mobile;

        /* Hero intro: title lines arrive from alternating sides */
        const lines = root.querySelectorAll('.nd-hero .nd-hero__line');
        if (lines.length) {
          animate(lines, {
            x: (_, i) => [`${(i % 2 ? 1 : -1) * dist * 0.6}vw`, '0vw'],
            opacity: [0, 1],
            duration: 1600,
            delay: stagger(140, { start: 150 }),
            ease: 'outExpo',
          });
        }
        const emblem = root.querySelector('.nd-hero__emblem');
        if (emblem) animate(emblem, { y: [-40, 0], opacity: [0, 1], duration: 1400, ease: 'outExpo' });
        const heroRest = root.querySelectorAll('.nd-hero__text, .nd-hero__inner > .nd-link');
        if (heroRest.length) {
          animate(heroRest, { y: [30, 0], opacity: [0, 1], duration: 1400, delay: stagger(100, { start: 550 }), ease: 'outExpo' });
        }
        done();

        /* Hero exits softly while scrolling away */
        const hero = root.querySelector('.nd-hero');
        const heroInner = root.querySelector('.nd-hero__inner');
        if (d.ndHeroExit === 'true' && hero && heroInner) {
          animate(heroInner, {
            y: ['0vh', '-12vh'],
            scale: [1, 0.94],
            opacity: [1, 0],
            ease: 'linear',
            autoplay: onScroll({ target: hero, enter: 'top top', leave: 'top bottom', sync: true }),
          });
        }

        /* Product rows: each card slides in from its own side */
        let mobileIndex = 0;
        root.querySelectorAll('.nd-row').forEach((row) => {
          const cards = row.querySelectorAll('.nd-card');
          if (mobile) {
            cards.forEach((card) => {
              const dir = mobileIndex++ % 2 ? 1 : -1;
              animate(card, {
                x: [`${dir * dist}vw`, '0vw'],
                rotate: [dir * tilt, 0],
                opacity: [0, 1],
                ...timing,
                autoplay: trigger(card, 'bottom top', '90% bottom'),
              });
            });
          } else {
            const rowRect = row.getBoundingClientRect();
            const mid = rowRect.left + rowRect.width / 2;
            cards.forEach((card) => {
              const r = card.getBoundingClientRect();
              const dir = r.left + r.width / 2 < mid ? -1 : 1;
              animate(card, {
                x: [`${dir * dist}vw`, '0vw'],
                rotate: [dir * tilt, 0],
                opacity: [0, 1],
                ...timing,
                autoplay: trigger(row, 'bottom top', 'bottom bottom'),
              });
            });
          }
        });

        /* Spotlight: bottle rises and grows, curved text turns with the scroll */
        root.querySelectorAll('.nd-spot').forEach((spot) => {
          const media = spot.querySelector('.nd-spot__media');
          const ring = spot.querySelector('.nd-spot__ring');
          const emblemSm = spot.querySelector('.nd-spot__emblem');
          if (media) {
            animate(media, {
              scale: [0.55, 1],
              y: ['20vh', '0vh'],
              opacity: [0, 1],
              ...timing,
              autoplay: trigger(spot, 'bottom top', 'center center'),
            });
          }
          if (ring && !spot.classList.contains('nd-spot--rotate')) {
            animate(ring, {
              rotate: [-100, 0],
              opacity: [0, 1],
              ease: scrub ? 'outQuad' : 'outExpo',
              duration: scrub ? 1000 : 1800,
              // Text comes to rest level when the spotlight reaches the middle of the screen
              autoplay: trigger(spot, 'bottom top', 'center center'),
            });
          }
          if (emblemSm) {
            animate(emblemSm, { y: [60, 0], opacity: [0, 1], ...timing, autoplay: trigger(emblemSm, 'bottom top', 'bottom bottom') });
          }
        });

        /* Headings and SEO text: alternate sides too */
        root.querySelectorAll('.nd-heading, .nd-seo, .nd-news, .nd-adv').forEach((el, i) => {
          const dir = i % 2 ? 1 : -1;
          animate(el, {
            x: [`${dir * dist * 0.5}vw`, '0vw'],
            opacity: [0, 1],
            ...timing,
            autoplay: trigger(el, 'bottom top', 'bottom bottom'),
          });
        });
      });

      scopes.set(root, scope);
    };

    /* ---------- Perfume advisor ---------- */
    const normalize = (str) =>
      (str || '')
        .toString()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9Ͱ-ϿЀ-ӿ]+/g, ' ')
        .trim();

    // Score how well a query matches a scenario (0 = no match)
    const scoreScenario = (query, haystack, name) => {
      if (!query) return 1;
      const q = normalize(query);
      const n = normalize(name);
      const h = normalize(haystack);
      if (!q) return 1;
      if (n === q) return 100;
      if (n.startsWith(q)) return 80;
      if (h.split(' ').some((w) => w.startsWith(q))) return 60;
      if (h.includes(q)) return 40;
      const tokens = q.split(' ').filter(Boolean);
      const hits = tokens.filter((t) => h.includes(t)).length;
      return hits === tokens.length ? 30 : hits ? 10 * hits : 0;
    };

    const advisors = new WeakMap();

    const initAdvisor = (wrap) => {
      if (advisors.has(wrap)) return;
      const openBtn = wrap.querySelector('[data-nd-adv-open]');
      const dialog = wrap.querySelector('[data-nd-adv-dialog]');
      const panel = wrap.querySelector('[data-nd-adv-panel]');
      const input = wrap.querySelector('[data-nd-adv-input]');
      const listView = wrap.querySelector('[data-nd-adv-view="list"]');
      const resultView = wrap.querySelector('[data-nd-adv-view="result"]');
      const options = [...wrap.querySelectorAll('[data-nd-adv-option]')];
      const results = [...wrap.querySelectorAll('[data-nd-adv-result]')];
      const noMatch = wrap.querySelector('[data-nd-adv-nomatch]');
      const searchLink = wrap.querySelector('[data-nd-adv-search-link]');
      const backBtn = wrap.querySelector('[data-nd-adv-back]');
      const closeBtn = wrap.querySelector('[data-nd-adv-close]');
      if (!openBtn || !dialog || !panel) return;

      const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let active = -1;
      let closing = false;

      const visibleOptions = () => options.filter((o) => !o.hidden);

      // idx = null clears the selection; numbers wrap around (for arrow keys)
      const setActive = (idx) => {
        const vis = visibleOptions();
        options.forEach((o) => o.setAttribute('aria-selected', 'false'));
        active = idx === null || !vis.length ? -1 : (idx + vis.length) % vis.length;
        if (active >= 0) {
          const el = vis[active];
          el.setAttribute('aria-selected', 'true');
          input.setAttribute('aria-activedescendant', el.id);
          el.scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      };

      const filter = () => {
        const q = input.value;
        const scored = options.map((o) => ({
          o,
          s: scoreScenario(q, o.dataset.search, o.querySelector('.nd-adv__option-name')?.textContent),
        }));
        scored.forEach(({ o, s }) => (o.hidden = s === 0));
        // Best matches first
        scored
          .filter(({ s }) => s > 0)
          .sort((a, b) => b.s - a.s)
          .forEach(({ o }) => o.parentElement.appendChild(o));
        const any = scored.some(({ s }) => s > 0);
        if (noMatch) noMatch.hidden = any || !q.trim();
        if (searchLink) {
          const base = searchLink.dataset.base;
          searchLink.href = `${base}?q=${encodeURIComponent(q.trim())}&type=product`;
        }
        setActive(q.trim() && any ? 0 : null);
      };

      const showList = () => {
        results.forEach((r) => (r.hidden = true));
        resultView.hidden = true;
        listView.hidden = false;
        backBtn.hidden = true;
        input.closest('.nd-adv__search').hidden = false;
      };

      const showResult = (id) => {
        const target = results.find((r) => r.dataset.ndAdvResult === id);
        if (!target) return;
        results.forEach((r) => (r.hidden = r !== target));
        listView.hidden = true;
        resultView.hidden = false;
        backBtn.hidden = false;
        input.closest('.nd-adv__search').hidden = true;
        panel.scrollTop = 0;
        backBtn.focus({ preventScroll: true });
      };

      // Expand from the search bar to full screen
      const barInset = () => {
        const r = openBtn.getBoundingClientRect();
        const radius = getComputedStyle(openBtn).borderTopLeftRadius;
        return `inset(${r.top}px ${innerWidth - r.right}px ${innerHeight - r.bottom}px ${r.left}px round ${radius})`;
      };

      const open = (scenarioId) => {
        if (dialog.open) {
          if (scenarioId) showResult(scenarioId);
          return;
        }
        closing = false;
        document.documentElement.classList.add('nd-modal-open');
        dialog.showModal();
        if (scenarioId) showResult(scenarioId);
        else {
          showList();
          filter();
          requestAnimationFrame(() => input.focus({ preventScroll: true }));
        }
        if (!reduce() && panel.animate) {
          panel.animate([{ clipPath: barInset() }, { clipPath: 'inset(0px 0px 0px 0px round 0px)' }], {
            duration: 650,
            easing: 'cubic-bezier(0.7, 0, 0.2, 1)',
          });
        }
      };

      const close = () => {
        if (!dialog.open || closing) return;
        closing = true;
        const finish = () => {
          dialog.close();
          document.documentElement.classList.remove('nd-modal-open');
          closing = false;
        };
        if (!reduce() && panel.animate) {
          const anim = panel.animate(
            [{ clipPath: 'inset(0px 0px 0px 0px round 0px)' }, { clipPath: barInset() }],
            { duration: 450, easing: 'cubic-bezier(0.7, 0, 0.2, 1)', fill: 'forwards' }
          );
          anim.onfinish = () => {
            finish();
            anim.cancel();
          };
        } else finish();
      };

      openBtn.addEventListener('click', () => open());
      closeBtn.addEventListener('click', close);
      backBtn.addEventListener('click', () => {
        showList();
        filter();
        input.focus({ preventScroll: true });
      });

      // Esc: go back from results first, then close
      dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        if (!resultView.hidden) backBtn.click();
        else close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('nd-modal-open');
        openBtn.focus({ preventScroll: true });
      });

      input.addEventListener('input', filter);
      input.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setActive(active + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setActive(active < 0 ? -1 : active - 1);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          const vis = visibleOptions();
          const pick = vis[active >= 0 ? active : 0];
          if (pick && (input.value.trim() || active >= 0)) showResult(pick.dataset.ndAdvOption);
          else if (!vis.length && searchLink && input.value.trim()) window.location.href = searchLink.href;
        }
      });

      // Hover highlights only after the pointer really moves (not when the modal opens under the cursor)
      let lastPointer = null;
      const list = options[0]?.parentElement;
      options.forEach((o) => {
        o.addEventListener('click', () => showResult(o.dataset.ndAdvOption));
        o.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse') return;
          const moved = lastPointer && Math.hypot(e.clientX - lastPointer.x, e.clientY - lastPointer.y) > 3;
          if (!lastPointer) lastPointer = { x: e.clientX, y: e.clientY };
          if (moved) setActive(visibleOptions().indexOf(o));
        });
      });
      list?.addEventListener('pointerleave', () => {
        if (!input.value.trim()) setActive(null);
      });
      dialog.addEventListener('close', () => (lastPointer = null));

      advisors.set(wrap, { open, close, showResult });
    };

    // Theme editor: selecting a scenario block opens the advisor on that scenario
    document.addEventListener('shopify:block:select', (e) => {
      const result = e.target.closest?.('[data-nd-adv-result]') || (e.target.matches?.('[data-nd-adv-result]') && e.target);
      const adv = e.target.closest?.('[data-nd-advisor]');
      if (result && adv && advisors.has(adv)) advisors.get(adv).open(result.dataset.ndAdvResult);
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      const adv = e.target.closest?.('[data-nd-advisor]');
      if (adv && advisors.has(adv) && e.target.matches?.('[data-nd-adv-result]')) advisors.get(adv).close();
    });

    const init = (root) => {
      if (!root || root.dataset.ndReady) return;
      root.dataset.ndReady = 'true';
      playVideos(root);
      root.querySelectorAll('[data-nd-advisor]').forEach(initAdvisor);

      const style = root.dataset.ndAnim;
      if (style === 'anime') initAnime(root);
      else if (style === 'fade') initFade(root);
    };

    const destroy = (root) => {
      const scope = scopes.get(root);
      if (scope) {
        scope.revert();
        scopes.delete(root);
      }
    };

    const run = () => document.querySelectorAll('[data-nd]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();

    // Theme editor support
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('[data-nd]').forEach(init);
    });
    document.addEventListener('shopify:section:unload', (e) => {
      e.target.querySelectorAll('[data-nd]').forEach(destroy);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perfume-advisor-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sliders = new Map();

    const init = (root) => {
      if (!root || sliders.has(root)) return;
      const stage = root.querySelector('[data-pas-stage]');
      const slides = [...root.querySelectorAll('[data-pas-slide]')];
      if (!stage || !slides.length) return;

      const prevBtn = root.querySelector('[data-pas-prev]');
      const nextBtn = root.querySelector('[data-pas-next]');
      const current = root.querySelector('[data-pas-current]');
      const progress = root.querySelector('[data-pas-progress]');
      const useHash = root.dataset.hash === 'true';
      const autoplayMs = (Number(root.dataset.autoplay) || 0) * 1000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = parseFloat(getComputedStyle(root).getPropertyValue('--pas-speed')) || 900;

      let index = slides.findIndex((s) => s.classList.contains('is-active'));
      if (index < 0) index = 0;
      let timer = null;
      let paused = false;
      let progressAnim = null;

      const pad = (n) => String(n).padStart(2, '0');

      const closeSenses = (slide) => {
        slide.querySelectorAll('[data-pas-card].is-senses').forEach((card) => toggleSenses(card, false));
      };

      const playVideo = (slide, play) => {
        slide.querySelectorAll('video').forEach((v) => {
          if (play) {
            v.muted = true;
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else v.pause();
        });
      };

      const restartProgress = () => {
        if (!progress) return;
        progressAnim?.cancel();
        if (!autoplayMs || reduce) {
          progress.style.transform = `scaleX(${(index + 1) / slides.length})`;
          return;
        }
        progressAnim = progress.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], {
          duration: autoplayMs,
          easing: 'linear',
          fill: 'forwards',
        });
        if (paused) progressAnim.pause();
      };

      const schedule = () => {
        clearTimeout(timer);
        if (!autoplayMs || reduce || paused || slides.length < 2 || window.Shopify?.designMode) return;
        timer = setTimeout(() => go(index + 1, 'next'), autoplayMs);
      };

      const go = (to, dir, opts = {}) => {
        const next = (to + slides.length) % slides.length;
        if (next === index && !opts.force) return;
        const from = slides[index];
        const target = slides[next];
        stage.dataset.dir = dir || (next > index ? 'next' : 'prev');

        closeSenses(from);
        slides.forEach((s) => s.classList.remove('is-leaving', 'is-entering'));

        if (from !== target) {
          from.classList.remove('is-active');
          from.classList.add('is-leaving');
          from.setAttribute('inert', '');
          from.setAttribute('aria-hidden', 'true');
          setTimeout(() => {
            from.classList.remove('is-leaving');
            playVideo(from, false);
          }, reduce ? 0 : speed);
        }

        target.classList.add('is-active');
        if (!reduce) {
          // restart the entrance animation
          void target.offsetWidth;
          target.classList.add('is-entering');
          setTimeout(() => target.classList.remove('is-entering'), speed * 1.6);
        }
        target.removeAttribute('inert');
        target.removeAttribute('aria-hidden');
        playVideo(target, true);

        index = next;
        if (current) current.textContent = pad(index + 1);
        if (useHash && !opts.silent && target.id) history.replaceState(null, '', `#${target.id}`);
        restartProgress();
        schedule();
      };

      const toggleSenses = (card, force) => {
        const btn = card.querySelector('[data-pas-plus]');
        const panel = card.querySelector('[data-pas-senses]');
        if (!btn || !panel) return;
        const open = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        card.classList.toggle('is-senses', open);
        paused = open || root.matches(':hover');
        if (open) {
          progressAnim?.pause();
          clearTimeout(timer);
        } else {
          progressAnim?.play();
          schedule();
        }
      };

      root.querySelectorAll('[data-pas-card]').forEach((card) => {
        card.querySelector('[data-pas-plus]')?.addEventListener('click', () => toggleSenses(card));
      });

      prevBtn?.addEventListener('click', () => go(index - 1, 'prev'));
      nextBtn?.addEventListener('click', () => go(index + 1, 'next'));

      // Keyboard: arrows when the slider is on screen and nothing else is focused for typing
      const onKey = (e) => {
        if (e.defaultPrevented || e.altKey || e.metaKey || e.ctrlKey) return;
        const t = e.target;
        if (t instanceof HTMLElement && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        if (document.querySelector('dialog[open]')) return;
        const r = stage.getBoundingClientRect();
        if (r.bottom < innerHeight * 0.4 || r.top > innerHeight * 0.6) return;
        if (e.key === 'ArrowLeft') go(index - 1, 'prev');
        else if (e.key === 'ArrowRight') go(index + 1, 'next');
        else if (e.key === 'Escape') closeSenses(slides[index]);
      };
      document.addEventListener('keydown', onKey);

      // Swipe
      let sx = null;
      let sy = null;
      stage.addEventListener('touchstart', (e) => {
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        const dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          if (e.target.closest('.pas-senses')) return;
          dx < 0 ? go(index + 1, 'next') : go(index - 1, 'prev');
        }
      }, { passive: true });

      // Pause autoplay on hover / focus
      const pause = () => {
        paused = true;
        clearTimeout(timer);
        progressAnim?.pause();
      };
      const resume = () => {
        if (root.querySelector('.is-senses')) return;
        paused = false;
        progressAnim?.play();
        schedule();
      };
      stage.addEventListener('mouseenter', pause);
      stage.addEventListener('mouseleave', resume);
      stage.addEventListener('focusin', pause);
      stage.addEventListener('focusout', (e) => {
        if (!stage.contains(e.relatedTarget)) resume();
      });

      // Header back to normal once the slider is scrolled past
      let io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(([entry]) => {
          document.body.classList.toggle('pas-past', !entry.isIntersecting);
        }, { rootMargin: '-80px 0px 0px 0px' });
        io.observe(stage);
      }

      // Deep link: /pages/advisor#nairobi
      if (useHash && location.hash) {
        const fromHash = slides.findIndex((s) => `#${s.id}` === decodeURIComponent(location.hash));
        if (fromHash > -1 && fromHash !== index) go(fromHash, 'next', { silent: true });
      }

      playVideo(slides[index], true);
      if (current) current.textContent = pad(index + 1);
      restartProgress();
      schedule();

      sliders.set(root, {
        go,
        slides,
        destroy() {
          clearTimeout(timer);
          progressAnim?.cancel();
          document.removeEventListener('keydown', onKey);
          io?.disconnect();
          document.body.classList.remove('pas-past');
        },
      });
    };

    const run = () => document.querySelectorAll('[data-pas]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();

    // Theme editor
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-pas]').forEach(init));
    document.addEventListener('shopify:section:unload', (e) => {
      e.target.querySelectorAll('[data-pas]').forEach((root) => {
        sliders.get(root)?.destroy();
        sliders.delete(root);
      });
    });
    document.addEventListener('shopify:block:select', (e) => {
      const slide = e.target.closest?.('[data-pas-slide]');
      const root = slide?.closest('[data-pas]');
      const api = root && sliders.get(root);
      if (api) api.go(api.slides.indexOf(slide), 'next', { silent: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
